import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { usePrevious } from '../../../../1stlog-ui/src/hooks'
import LoaderOverlay from '../../../../1stlog-ui/src/components/LoaderOverlay'
import ChevronToggle from '../../../../1stlog-ui/src/components/ChevronToggle'
import Item from './Item'
import useTariffs from '../useTariffs'
import { parseTree } from '../utils'
import { requestById } from '../requests'

const Wrapper = styled.div`
  position: relative;
  margin-left: ${({ level }) => (level > 0 ? 30 : 0)}px;
`

const Line = styled.div`
  position: absolute;
  top: 0;
  left: -18px;
  width: 18px;
  bottom: ${({ isLast }) => (isLast ? '' : '0')};
  height: ${({ isLast }) => (isLast ? '14px' : '')};
  border-left: 1px solid rgba(0, 0, 0, 0.1);
`

const LineRight = styled.div`
  position: absolute;
  top: 0;
  left: -18px;
  width: 18px;
  height: 9px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`

const TitleWrapper = styled.div`
  flex: 1;
  display: flex;

  :hover {
    background: rgba(0, 0, 0, 0.03);
  }
`

const Title = styled.div`
  flex: 1;
  margin: 5px 0;
`

const Node = (props) => {
  const {
    parentPath,
    node,
    level,
    onSelect,
    isLast,
    initiallyExpanded,
    search,
    trace = [],
    country,
    mode
  } = props

  // console.log("Node", { node, initiallyExpanded })
  const {
    meta: { id, type, name, description, isLoaded, isRoot },
    meta,
    ...children
  } = node

  const { mergeTree } = useTariffs()

  const [internalChildren, setInternalChildren] = useState()

  const [isExpanded, setIsExpanded] = useState(initiallyExpanded)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const path = parentPath ? `${parentPath}/${id}` : id

  const load = async () => {
    try {
      setIsLoading(true)
      setError(undefined)

      // load path
      // await new Promise(resolve => {
      //   setTimeout(resolve, 1000)
      // })
      // setInternalChildren([])
      // setIsLoading(false)
      const data = await requestById({ mode, id })
      // const { data } = await request({
      //   method: "GET",
      //   url: `/api/ztn/${country === "CH1" ? "tares" : "taric/eu"}/${path}`
      // })
      const parsedTree = parseTree(lodash.first(data))
      // console.log("DATA for byId", { data, parsedTree })
      mergeTree(parsedTree)
    } catch (err) {
      console.error('Failed to load tariff subtree', err)
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }

  const previousIsExpanded = usePrevious(isExpanded)
  useEffect(() => {
    if (type === 'item') {
      return
    }
    if (isExpanded && previousIsExpanded !== isExpanded && !isLoaded && !search) {
      load()
    }
  }, [isExpanded])

  const toggle = () => setIsExpanded(!isExpanded)

  return (
    <Wrapper level={level}>
      <Line isLast={isLast} />
      <LineRight />
      {/* <div>LEVEL: {level}</div> */}
      {type === 'item' ? (
        <Item meta={meta} onSelect={onSelect} trace={trace} />
      ) : (
        <>
          <div className="d-flex">
            <LoaderOverlay isLoading={isLoading} />
            <div className="d-inline-block" style={{ minWidth: '30px', marginTop: '5px' }}>
              <ChevronToggle
                isToggled={isExpanded}
                onClick={toggle}
                inline
                toTheRight
                className="mx-1"
              />
            </div>
            {/* <Button icon="fas fa-chevron-down" onClick={toggle} /> */}
            {/* <code>{path}</code> |  */}
            <TitleWrapper className="d-inline-block" style={{ cursor: 'pointer' }} onClick={toggle}>
              <Title>
                <div className="d-flex align-items-start">
                  <div className="mr-1">{name}</div>
                  <div>{description}</div>
                </div>
              </Title>
            </TitleWrapper>
          </div>
          {isExpanded && (
            <div>
              {isLoaded ? (
                lodash.map(children, (child, index) => (
                  <Node
                    node={child}
                    level={level + 1}
                    onSelect={onSelect}
                    parentPath={path}
                    isLast={lodash.size(children) - 1 === index}
                    initiallyExpanded={initiallyExpanded}
                    search={search}
                    trace={[...trace, meta]}
                    country={country}
                    mode={mode}
                  />
                ))
              ) : (
                // <div>{i18n.t('is_loading', 'Wird geladen...')}</div>
                <div className="ml-4">
                  {!isLoading && <div className="text-muted">{i18n.t(`no_entries_found`, `Keine Einträge gefunden`)}</div>}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </Wrapper>
  )
}

export default Node
